<template>
  <b-row class="wrap-page-loading">
    <b-col
      v-for="i in 9"
      :key="i"
      cols="12"
      md="4"
      class="col"
    >
      <Skeleton
        width="100%"
        height="20em"
      />
    </b-col>
  </b-row>
</template>

<script>
const Skeleton = () => import('@/components/Loading/Skeleton')

export default {
  components: {
    Skeleton
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.wrap-page-loading {
  padding-top: 22px;

  .col {
    margin-bottom: 15px;
  }
}
</style>
